module.exports = __webpack_public_path__ + "static/media/clouds.ffa95a70.mp4";